import React from 'react';
import Icon from '../Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import './style.scss';

interface IProps {
  onCancel?: () => void;
}

export default class SpinLoader extends React.Component<IProps, {}> {
  render() {
    return (
      <div className="spin-loader">
        <div className="spin-loader__spinner" />
        {this.props.onCancel !== undefined && <Icon name={Icons.Close} size={24} className="spin-loader__cross" onPress={this.props.onCancel} />}
      </div>
    );
  }
}
